<template>
    <fieldable 
        :label="label"
        :name="name"
        :required="required"
        :errors="errors"
        :no="independent">
        <template #label>
            <span>
                {{ label }}
                <el-tooltip content="Корпус или благоустройство"
                            placement="right">
                    <i class="el-icon-question" />
                </el-tooltip>
            </span>
        </template>
        
        <div class="f-y-center space-x-0.5 w-full">
            <el-checkbox :value="isLandscaping"
                         :disabled="disabled"
                         @change="changeLandscaping">
                {{ labels.isLandscaping }}
            </el-checkbox>
                                
            <!-- Select place -->
            <el-input :value="value"
                      size="mini"
                      :disabled="disabled || isLandscaping"
                      :placeholder="placeholder"
                      @input="change" />
        </div>
    </fieldable>
</template>

<script>
import { injectCommonFieldProps } from '@/utils/ui'

import Fieldable from '@/components/fields/Fieldable'

const labels = {
  label: 'Местонахождение',
  placeholder: 'Введите корпус',
  isLandscaping: 'Благоустройство или'
}

export default {
  components: {
    Fieldable
  },

  model: { prop: 'value', event: 'change' },
  
  props: {
    ...injectCommonFieldProps({
      defaultLabel: labels.label,
      defaultPlaceholder: labels.placeholder
    }),

    value: { type: String, default: null }
  },

  data() {
    return {
      labels
    }
  },

  computed: {
    isLandscaping() {
      return this.value === null
    }
  },

  methods: {
    changeLandscaping(x) {
      this.change(x ? null : '')
    },

    change(x) {
      this.$emit('change', x)
    }
  }
}
</script>
